'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = camelCaseObject;

var _camelCase = require('lodash/camelCase');

var _camelCase2 = _interopRequireDefault(_camelCase);

var _mapKeys = require('lodash/mapKeys');

var _mapKeys2 = _interopRequireDefault(_mapKeys);

var _mapValues = require('lodash/mapValues');

var _mapValues2 = _interopRequireDefault(_mapValues);

var _isPlainObject = require('lodash/isPlainObject');

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapObject(obj, callback) {
  if (Array.isArray(obj)) {
    return obj.map(function (value) {
      return mapObject(value, callback);
    });
  }

  if (!(0, _isPlainObject2.default)(obj)) {
    return obj;
  }

  var mappedObject = (0, _mapKeys2.default)(obj, function (value, key) {
    return callback(key);
  });

  return (0, _mapValues2.default)(mappedObject, function (value) {
    return mapObject(value, callback);
  });
}

function camelCaseObject(obj) {
  if (!(0, _isPlainObject2.default)(obj)) {
    return obj;
  }

  return mapObject(obj, _camelCase2.default);
}
//# sourceMappingURL=camelCaseObject.js.map